import React from 'react'
import { SvgIcon } from '@material-ui/core'

const DeleteIcon = (props) => {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="18.688" height="23" viewBox="0 0 18.688 23">
      <g id="Group_5379" data-name="Group 5379" transform="translate(-76.156 -203)">
        <path id="Path_12536" data-name="Path 12536" className="cls-1" d="M93.047 205.875h-3.953v-.719A2.156 2.156 0 0 0 86.938 203h-2.875a2.157 2.157 0 0 0-2.157 2.156v.719h-3.953a1.8 1.8 0 0 0-1.8 1.8v1.437a.719.719 0 0 0 .719.719h17.25a.719.719 0 0 0 .719-.719v-1.437a1.8 1.8 0 0 0-1.794-1.8zm-5.391 0h-4.312v-.719a.719.719 0 0 1 .719-.718h2.875a.719.719 0 0 1 .718.718z" />
        <path id="Path_12537" data-name="Path 12537" className="cls-1" d="M93.48 211.266H77.521a.225.225 0 0 0-.225.235l.593 12.445A2.154 2.154 0 0 0 80.043 226h10.915a2.153 2.153 0 0 0 2.153-2.054L93.7 211.5a.224.224 0 0 0-.22-.234zm-10.855 11.14a.718.718 0 1 1-1.437 0v-9.343a.718.718 0 1 1 1.437 0zm3.594 0a.719.719 0 0 1-1.438 0v-9.343a.719.719 0 1 1 1.438 0zm3.594 0a.719.719 0 0 1-1.438 0v-9.343a.719.719 0 1 1 1.438 0z" />
      </g>
    </SvgIcon>
  )
}

export default DeleteIcon
